// List of cookies to block
    // '_shopify_s',
    // '_shopify_y',
    // 'receive-cookie-deprecation',
    // 'ZD-store',
    // '1.gif'
const BLOCKED_COOKIES = [];

// Function to block specific cookies
function blockCookies() {
    // Override the default document.cookie setter
    const cookieDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
                            Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
    
    if (cookieDescriptor && cookieDescriptor.configurable) {
        Object.defineProperty(document, 'cookie', {
            get: function() {
                return cookieDescriptor.get.call(document);
            },
            set: function(val) {
                // Check if the cookie being set matches any in our blocked list
                const cookieName = val.split('=')[0].trim();
                
                // If the cookie is not in our blocked list, allow it to be set
                if (!BLOCKED_COOKIES.some(blocked => cookieName === blocked)) {
                    cookieDescriptor.set.call(document, val);
                } else {
                    // console.log(`Blocked cookie: ${cookieName}`);
                }
            },
            configurable: true
        });
    }
}

// Function to remove existing blocked cookies
function removeExistingCookies() {
    const cookies = document.cookie.split(';');
    
    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        if (BLOCKED_COOKIES.includes(cookieName)) {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
            // console.log(`Removed existing cookie: ${cookieName}`);
        }
    });
}

// Initialize the cookie blocker
function initCookieBlocker() {
    blockCookies();
    removeExistingCookies();
    // console.log('Cookie blocker initialized');
}

// Run the cookie blocker when the page loads
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBlocker);
} else {
    initCookieBlocker();
} 